var map = {
	"./Pranita-img.jpg": 30,
	"./ccp.jpg": 9,
	"./ccp/img1.jpg": 31,
	"./ccp/img2.jpg": 32,
	"./ccp/img3.jpg": 33,
	"./ccp/img4.jpg": 34,
	"./ccp/img5.jpg": 35,
	"./ccp/img6.jpg": 36,
	"./ccp/img7.jpg": 37,
	"./fabindia.jpg": 10,
	"./fabindia/img1.jpg": 38,
	"./fabindia/img2.jpg": 39,
	"./fabindia/img3.jpg": 40,
	"./fabindia/img4.jpg": 41,
	"./fabindia/img5.jpg": 42,
	"./headsprout.jpg": 11,
	"./headsprout/img1.jpg": 43,
	"./headsprout/img2.jpg": 44,
	"./headsprout/img3.jpg": 45,
	"./headsprout/img4.jpg": 46,
	"./headsprout/img5.jpg": 47,
	"./headsprout/img6.jpg": 48,
	"./headsprout/img7.jpg": 49,
	"./headsprout/img8.jpg": 50,
	"./img.jpg": 51,
	"./isl.jpg": 12,
	"./isl/img1.jpg": 52,
	"./isl/img10.jpg": 53,
	"./isl/img11.jpg": 54,
	"./isl/img12.jpg": 55,
	"./isl/img13.jpg": 56,
	"./isl/img14.jpg": 57,
	"./isl/img15.jpg": 58,
	"./isl/img16.jpg": 59,
	"./isl/img2.jpg": 60,
	"./isl/img3.jpg": 61,
	"./isl/img4.jpg": 62,
	"./isl/img5.jpg": 63,
	"./isl/img6.jpg": 64,
	"./isl/img7.jpg": 65,
	"./isl/img8.jpg": 66,
	"./isl/img9.jpg": 67,
	"./kornferry.jpg": 13,
	"./kornferry/img1.jpg": 68,
	"./kornferry/img2.jpg": 69,
	"./kornferry/img3.jpg": 70,
	"./kornferry/img4.jpg": 71,
	"./tce/img1.jpg": 72,
	"./tce/img2.jpg": 73,
	"./tce/img3.jpg": 74,
	"./tce/img4.jpg": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;